import type { RoleConfig } from '../types.js';

export const watcher: RoleConfig = {
  id: 'watcher',
  faction: 'town',
  title: { ru: 'Наблюдатель', uk: 'Спостерігач' },
  latin: 'WATCHER',
  number: '19',
  accent: '#bcd8ff',
  ability: {
    ru: 'Ночью наблюдает за игроком — узнаёт, кто к нему приходил.',
    uk: 'Вночі стежить за гравцем — дізнається, хто до нього приходив.',
  },
  abilities: [
    { key: 'watch', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
